// third-party
import merge from 'lodash/merge';

// project import
import Badge from './Badge';
import Button from './Button';
import Checkbox from './Checkbox';
import Chip from './Chip';
import IconButton from './IconButton';
import InputLabel from './InputLabel';
import LinearProgress from './LinearProgress';
import Link from './Link';
import ListItemIcon from './ListItemIcon';
import OutlinedInput from './OutlinedInput';
import Tab from './Tab';
import TableCell from './TableCell';
import Tabs from './Tabs';
import Typography from './Typography';
import { CustomTheme } from 'themes/Theme';
import Stack from './Stack';

// ==============================|| OVERRIDES - MAIN ||============================== //

export default function ComponentsOverrides(theme: CustomTheme) {
    return merge(
        Button(theme),
        Badge(theme),
        Checkbox(theme),
        Chip(theme),
        IconButton(theme),
        InputLabel(theme),
        LinearProgress(),
        Link(),
        ListItemIcon(),
        OutlinedInput(theme),
        Tab(theme),
        TableCell(theme),
        Tabs(),
        Typography(),
        Stack(),
    );
}
